import React, { ReactNode } from "react";

type Size = "sm" | "md" | "md-fix" | "lg" | "lg-fix";

/**
 * サイズをTailwindクラスに変換
 * @param {Size} s
 */
function sizeToClass(s?: Size): string {
  switch (s) {
    case "sm":
      return "md:px-4 md:text-sm md:md:w-auto md:h-8";
    case "lg-fix":
      return "md:h-[49px] md:w-full md:px-3 md:rounded-lg";
    case "lg":
      return "md:md:w-auto md:h-[49px] md:px-6 md:rounded-lg";
    case "md-fix":
      return "md:w-full md:h-10 md:rounded";
    case "md":
    default:
      return "md:w-auto md:py-2 md:px-4 md:rounded";
  }
}

function sizeToSPClass(s?: Size): string {
  switch (s) {
    case "sm":
      return "h-10 px-4 rounded";
    case "lg-fix":
      return "h-[49px] w-full px-2 rounded-lg";
    case "lg":
      return "h-[49px] px-6 rounded-lg";
    case "md-fix":
      return "w-full h-10 rounded";
    case "md":
    default:
      return "h-10 px-4 rounded";
  }
}

type Color = "default" | "primary" | "secondary" | "white";

/**
 * カラーをTailwindクラスに変換
 * @param {Color} c
 */
function colorToClasses(c?: Color) {
  switch (c) {
    case "primary":
      return "border-primary hover:bg-primary-hover bg-white text-primary";
    case "white":
      return "border-white hover:bg-white/80 text-white";
    case "default":
    default:
      return "border-gray-500 hover:bg-gray-500 text-gray-700";
  }
}

interface Props {
  size?: Size;
  spSize?: Size;
  color?: Color;
  children?: ReactNode;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
  type?: "button" | "submit";
  rounded?: boolean;
  customClass?: string;
}

export default function OutlineButton(props: Props) {
  const {
    children,
    size,
    spSize,
    color,
    onClick,
    disabled,
    type = "button",
    rounded,
    customClass = "",
    ...other
  } = props;

  const sizeClass = sizeToClass(size);
  const spSizeClass = sizeToSPClass(spSize ?? size);
  const colorClasses = colorToClasses(color);
  const roundedClass = rounded ? "rounded" : "";

  return (
    <button
      className={`${sizeClass} ${spSizeClass} ${colorClasses} ${roundedClass} ${customClass} md:font-semibold border disabled:opacity-30 disabled:pointer-events-none md:transition`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...other}
    >
      {children}
    </button>
  );
}
